<!-- Tab Navigation Component -->
<!-- <app-tab-navigation *ngIf="isToken && isDashboardPage" [activeTab]="selectedMainTab" [tabs]="displayMainTabs"
  (tabChange)="onTabChange($event)">
</app-tab-navigation> -->

<!-- <div *ngIf="isToken && isDashboardPage" class="flex justify-end w-full pt-4 pr-4">
  <div class="flex w-full max-w-xs">
    <div class="relative flex-1">
      <input type="text" placeholder="Search..." [(ngModel)]="searchTerm" (input)="onSearch()"
        class="w-full bg-transparent text-white border border-[#2ee4e8] rounded-lg py-2 px-4 pl-10 focus:outline-none focus:ring-2 focus:ring-cyan-400" />
      <svg class="w-5 h-5 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2" fill="none"
        stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
    </div>
  </div>
</div> -->

<div id="games-scroll-id"
  class="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 2xl:grid-cols-6 3xl:grid-cols-8 gap-2 sm:gap-3 lg:gap-1 2xl:gap-1 mx-auto text-center px-2 sm:px-4 lg:px-8 py-2 sm:pb-4">
  <div *ngFor="let game of displayedGames; let i = index" class="game-card-wrapper">

    <div (click)="OnPlayNow(game)" class="cursor-pointer group mt-3 relative mx-auto
           w-full max-w-[115px] h-[165px]
           sm:max-w-[140px] sm:h-[210px]
           md:max-w-[190px] md:h-[225px]
           rounded-[15px]
           overflow-hidden
           cursor-pointer
           transition-all
           duration-300
           hover:-translate-y-2
           hover:scale-[1.02]">

      <!-- Card Border -->
      <div class="absolute inset-0 rounded-[15px] p-[1px]" [ngStyle]="{
  background:
    'linear-gradient(180deg,' +
    game.bgclr +
    ',rgba(255,255,255,.15),#1b2236)'
}">

        <div class="relative w-full h-full rounded-[15px] overflow-hidden bg-[#111827]">

          <!-- TOP GRADIENT -->
          <div class="absolute inset-x-0 top-0 h-[84%]" [ngStyle]="{
  background:
    'linear-gradient(180deg,' +
    game.bgclr +
    ' 0%,' +
    game.color2 +
    ' 55%,' +
    game.color3 +
    ' 100%)'
}"></div>

          <!-- Glow -->
          <div class="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-500" [ngStyle]="{
  background:
    'radial-gradient(circle at center,' +
    game.color2 +
    '55,transparent 70%)'
}"></div>

          <!-- CONTENT -->
          <div class="relative z-20 h-full flex flex-col">

            <!-- TOP BADGES -->
            <div class="relative px-3 pt-3">

              <!-- HOT Ribbon FIXED -->
              <!-- HOT Ribbon -->
              <div *ngIf="game.isHot" class="absolute top-0 left-0 z-30 w-[58px] h-[58px] overflow-hidden">

                <div class="absolute -left-[24px] top-[5px]
           w-[78px] text-center
           -rotate-45
           bg-[#ED314E]
           text-white text-[10px] font-extrabold
           py-[2px]
           shadow-[0_2px_6px_rgba(0,0,0,.5)]
           border-y border-white/30 tracking-wide">

                  HOT
                </div>

              </div>

              <!-- BONUS (unchanged but stable) -->
              <!-- BONUS Badge -->
              <div *ngIf="game?.bonus" class="absolute -top-0.5 -right-0.5 z-30">

                <div class="relative
             min-w-[42px] h-[22px]
             rounded-bl-[10px]
             bg-[#ED314E]
             border border-white/30
             shadow-[0_3px_8px_rgba(0,0,0,.45)]
             flex items-center justify-center
             px-2">

                  <span class="text-white text-[11px] font-extrabold leading-none">
                    {{ game.bonus }}%
                  </span>

                  <!-- Shine -->
                  <div class="absolute top-[2px] left-[4px] right-[4px]
                 h-[5px] rounded-full
                 bg-white/30">
                  </div>

                </div>

              </div>

            </div>

            <!-- IMAGE -->
            <div class="flex-1 flex items-center justify-center w-full">

              <img [src]="game.image" [alt]="game.name" class="max-w-[85%]
                     max-h-[150px]
                     object-contain
                     transition-all
                     duration-500
                     group-hover:scale-110
                     animate-flip-on-hover
                     animate-continuous-flip" />

            </div>

            <!-- FOOTER -->
            <div class="relative
                   bg-[#111827]
                   h-[40px]
                   border-t
                   border-white/10
                   px-3
                   flex
                   flex-col
                   justify-center">
              <!--
              <h3 class="font-bold
                     uppercase
                     truncate
                     text-white
                     text-[15px]">
                {{ game.name === 'Juwa2' ? 'Juwa2.0' : game.name }}
              </h3> -->

              <div class="mt-1">

                <!-- Game Name (smaller) -->
                <div class="flex items-start">
                  <span class="font-semibold ml-1 uppercase truncate text-white text-[11px]">
                    {{ game.name === 'Juwa2' ? 'Juwa2.0' : game.name }}
                  </span>
                </div>

                <!-- Button Row (second line) -->
                <div class="flex items-start mt-0 md:mt-1 ">

                  <!-- Play/Active Button -->
                  <button *ngIf="game.buttonText != ''" (click)="$event.stopPropagation(); OnPlayNow(game)"
                    class="flex items-center text-[9px] font-bold transition-colors duration-300"
                    [ngClass]="game.buttonText === 'Play Now' ? 'text-emerald-400 hover:text-emerald-200' : 'text-[#5D6783] hover:text-[#F3C14A]'">

                    <!-- Play Icon -->
                    <svg *ngIf="game.buttonText !== 'Play Now'" xmlns="http://www.w3.org/2000/svg"
                      class="w-3 h-3 text-current transition-colors duration-300" viewBox="0 0 24 24"
                      fill="currentColor">
                      <path d="M8 5v14l11-7z" />
                    </svg>

                    <!-- Text -->
                    <span *ngIf="game.buttonText !== 'Play Now'" class="ml-1">
                      Play
                    </span>

                    <span *ngIf="game.buttonText === 'Play Now'"
                      class="ml-1 inline-flex items-center gap-1 text-emerald-400">
                      <span class="h-2 w-2 rounded-full bg-emerald-400"></span>
                      Active
                    </span>
                  </button>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>
</div>

<!-- instant games cards  -->

<div class="mb-2 " id="quick-scrolling-id">
  <h2 class="text-[20px] mt-6 pl-4 font-extrabold italic uppercase leading-none">
    <span class="text-white drop-shadow-[1px_1px_0px_rgba(0,0,0,0.5)]">
      QUICK
    </span>
    <span class="bg-gradient-to-b from-[#F5CF6B] via-[#FFD970] to-[#F5CF6B]
           bg-clip-text text-transparent
           drop-shadow-[1px_1px_0px_rgba(0,0,0,0.4)]">
      GAMES
    </span>
  </h2>
  <div
    class="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 2xl:grid-cols-6 3xl:grid-cols-8 gap-2 sm:gap-3 lg:gap-1 2xl:gap-1 mx-auto text-center px-2 sm:px-4 lg:px-8 py-2 sm:pb-4">
    <div *ngFor="let game of quickGames; let i = index" class="quick-game-card-wrapper">
      <div (click)="redirectTo(game)" class="cursor-pointer group mt-3 relative mx-auto
          w-full max-w-[115px] h-[165px]
           sm:max-w-[140px] sm:h-[210px]
           md:max-w-[190px] md:h-[225px]
           rounded-[15px]
           overflow-hidden
           cursor-pointer
           transition-all
           duration-300
           hover:-translate-y-2
           hover:scale-[1.02]">

        <!-- Card Border -->
        <div class="absolute inset-0 rounded-[15px] p-[1px]" [ngStyle]="{
  background:
    'linear-gradient(180deg,' +
    game.bgclr +
    ',rgba(255,255,255,.15),#1b2236)'
}">

          <div class="relative w-full h-full rounded-[15px] overflow-hidden bg-[#111827]">

            <!-- TOP GRADIENT -->
            <div class="absolute inset-x-0 top-0 h-[84%]" [ngStyle]="{
  background:
    'linear-gradient(180deg,' +
    game.bgclr +
    ' 0%,' +
    game.color2 +
    ' 55%,' +
    game.color3 +
    ' 100%)'
}"></div>

            <!-- Glow -->
            <div class="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-500" [ngStyle]="{
  background:
    'radial-gradient(circle at center,' +
    game.color2 +
    '55,transparent 70%)'
}"></div>

            <!-- CONTENT -->
            <div class="relative z-20 h-full flex flex-col">

              <!-- TOP BADGES -->
              <div class="relative px-3 pt-3">

                <!-- HOT Ribbon -->
                <div *ngIf="game.isHot" class="absolute top-0 left-0 z-30 w-[58px] h-[58px] overflow-hidden">
                  <div class="absolute -left-[24px] top-[5px]
             w-[78px] text-center
             -rotate-45
             bg-[#ED314E]
             text-white text-[10px] font-extrabold
             py-[2px]
             shadow-[0_2px_6px_rgba(0,0,0,.5)]
             border-y border-white/30 tracking-wide">
                    HOT
                  </div>
                </div>

                <!-- BONUS Badge -->
                <div *ngIf="game?.bonus" class="absolute -top-0.5 -right-0.5 z-30">
                  <div class="relative
               min-w-[42px] h-[22px]
               rounded-bl-[10px]
               bg-[#ED314E]
               border border-white/30
               shadow-[0_3px_8px_rgba(0,0,0,.45)]
               flex items-center justify-center
               px-2">
                    <span class="text-white text-[11px] font-extrabold leading-none">
                      {{ game.bonus }}%
                    </span>
                    <div class="absolute top-[2px] left-[4px] right-[4px]
                   h-[5px] rounded-full
                   bg-white/30">
                    </div>
                  </div>
                </div>
              </div>

              <!-- IMAGE -->
              <div class="flex-1 flex items-center justify-center w-full">
                <img [src]="game.image" [alt]="game.name" class="max-w-[80%]
                       max-h-[120px]
                       object-contain
                       transition-all
                       duration-500
                       group-hover:scale-110
                       animate-flip-on-hover
                       animate-continuous-flip" />
              </div>

              <!-- FOOTER -->
              <div class="relative
                     bg-[#111827]
                     h-[40px]
                     border-t
                     border-white/10
                     px-3
                     flex
                     flex-col
                     justify-center">
                <div class="mt-1">
                  <!-- Game Name (smaller) -->
                  <div class="flex items-start">
                    <span class="font-semibold ml-1 uppercase truncate text-white text-[11px]">
                      {{ game.name }}
                    </span>
                  </div>

                  <!-- Button Row (second line) -->
                  <div class="flex items-start mt-1">
                    <!-- Desktop Button -->
                    <button *ngIf="!isMobile() && game.buttonText != ''" (click)="$event.stopPropagation(); redirectTo(game)"
                      class="flex items-start text-[9px] font-bold text-[#5D6783] transition-colors duration-300 hover:text-[#F3C14A]">
                      <!-- Play Icon -->
                      <svg xmlns="http://www.w3.org/2000/svg"
                        class="w-3 h-3 text-[#5D6783] transition-colors duration-300 group-hover:text-[#F3C14A]"
                        viewBox="0 0 24 24" fill="currentColor">
                        <path d="M8 5v14l11-7z" />
                      </svg>
                      <!-- Text -->
                      {{ game.buttonText }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="mb-10">
  <app-tab-navigation *ngIf="isToken && isDashboardPage" [activeTab]="lotteryTab[0].value" [tabs]="lotteryTab"
    (tabChange)="onTabChange($event)">
  </app-tab-navigation>
</div>

<div>
  <app-cmax-games *ngIf="!isDashboardPage" id="gameScrollSection"></app-cmax-games>
  <app-on-boarding-steps *ngIf="!isDashboardPage"></app-on-boarding-steps>
  <app-spin *ngIf="!isDashboardPage" id="spinnerScrollSection"></app-spin>
  <app-about-us *ngIf="!isDashboardPage" id="aboutScrollSection"></app-about-us>
  <app-lottery-cards id="lottriesScrollSection"></app-lottery-cards>
  <app-lottery-landing *ngIf="!isDashboardPage"></app-lottery-landing>
</div>

<div class="mb-10">
  <app-tab-navigation *ngIf="isDashboardPage" [activeTab]="ScratchTab[0].value" [tabs]="ScratchTab"
    (tabChange)="onTabChange($event)">
  </app-tab-navigation>
</div>

<div>
  <app-join-community *ngIf="!isDashboardPage"></app-join-community>

  <app-sectrech-card-list id="scratchScrollSection" [isHomePage]="router.url == '/' ? true : false">
  </app-sectrech-card-list>

  <div *ngIf="isDashboardPage" class="flex justify-center mt-8 mb-6 w-full col-span-full">
    <button (click)="toggleShowAllScratch()"
      class="px-6 py-2 --button text-black font-semibold rounded-lg shadow-md hover:opacity-90 transition">
      Show All
    </button>
  </div>
</div>

<div class="mt-10">
  <app-tab-navigation *ngIf="isDashboardPage" [activeTab]="SpinnerTab[0].value" [tabs]="SpinnerTab"
    (tabChange)="onTabChange($event)">
  </app-tab-navigation>
  <app-spinner id="spin-scrolling-id" *ngIf="!isLandingPage" [showHeaderSection]="false"></app-spinner>
</div> -->

<!-- Login popup (shown when a logged-out user clicks a game) -->
<div *ngIf="showLoginModal" class="fixed inset-0 z-[1100]">
  <app-login [isPopup]="true" (closed)="closeLoginModal()"></app-login>
</div>
